import React from "react";
import ReactDOM from "react-dom";

import "./i18n";

import App from "./App";

import { Provider } from "react-redux";
import { configureStore } from "./redux/store";

import "./helpers/analytics"; // Ensure Firebase app is initialized early

// AWS Amplify
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { logError } from "./helpers/errorLogger";
import { registerServiceWorker } from "./helpers/registerServiceWorker";

// Suppress ResizeObserver loop errors that are common in charting libraries
window.addEventListener("error", (e) => {
  if (
    e.message === "ResizeObserver loop limit exceeded" ||
    e.message === "ResizeObserver loop completed with undelivered notifications."
  ) {
    const resizeObserverErrGuid = "HG_ResizeObserver_SkipLines";
    if (!window[resizeObserverErrGuid]) {
      window[resizeObserverErrGuid] = true;
      setTimeout(() => {
        window[resizeObserverErrGuid] = false;
      }, 100);

      const resizeObserverErr = document.getElementById(
        "webpack-dev-server-client-overlay-div"
      );
      const resizeObserverErr2 = document.getElementById(
        "webpack-dev-server-client-overlay"
      );
      if (resizeObserverErr) {
        resizeObserverErr.style.display = "none";
      }
      if (resizeObserverErr2) {
        resizeObserverErr2.style.display = "none";
      }
    }
    e.stopImmediatePropagation();
    console.error("ResizeObserver thrown and suppressed:", e.message);
  }
});

Amplify.configure(awsExports);

window.addEventListener("error", (event) => {
  // ResizeObserver errors are suppressed above — skip them here too
  if (
    event.message === "ResizeObserver loop limit exceeded" ||
    event.message === "ResizeObserver loop completed with undelivered notifications."
  ) {
    return;
  }
  logError(event.error?.message ?? event.message, {
    stack: event.error?.stack,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  logError(event.reason?.message ?? String(event.reason), {
    stack: event.reason?.stack,
  });
});
ReactDOM.render(
  <Provider store={configureStore({})}>
    <App />
  </Provider>,
  document.getElementById("root")
);

// Register the push service worker (push-only, no asset caching). Safe no-op where
// service workers are unavailable.
registerServiceWorker();
